import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import EventBoundaryPopover from './EventBoundaryPopover';
import LinkForm from './LinkForm';
import { encodeUrl, ensureUrlHasProtocol } from '../utils/libUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const isNotDefined = value => value === undefined || value === null;
export default (Child => {
  class ImageLinkPopover extends PureComponent {
    constructor(props) {
      super(props);
      this.getCleanState = () => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'url' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
        let {
          url,
          isTargetBlank,
          isNoFollow
        } = this.props;
        if (isNotDefined(url)) {
          url = '';
        }
        if (isNotDefined(isTargetBlank)) {
          isTargetBlank = true;
        }
        if (isNotDefined(isNoFollow)) {
          isNoFollow = false;
        }
        return {
          url,
          isTargetBlank,
          isNoFollow
        };
      };
      this.clearInput = () => {
        this.setState(this.getCleanState());
      };
      this.togglePopover = e => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'open' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        const {
          open,
          onOpen,
          onCancel
        } = this.props;
        this.clearInput();

        // lifted from image componenet
        // without these two calls, the click will propagate up the chain
        // causing many unintended side effects
        e.preventDefault();
        e.stopPropagation();
        if (open) {
          onCancel();
        } else {
          onOpen();
        }
      };
      this.handleChange = state => {
        this.setState(state);
      };
      this.handleConfirm = () => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'url' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
        const {
          url,
          isTargetBlank,
          isNoFollow
        } = this.state;
        const urlWithProtocol = ensureUrlHasProtocol(url);
        const encodedUrl = encodeUrl(urlWithProtocol);
        this.props.onConfirm({
          url: encodedUrl,
          isTargetBlank,
          isNoFollow
        });
      };
      this.handleCancel = () => {
        this.clearInput();
        this.props.onCancel();
      };
      this.handleRemove = () => {
        this.props.onRemove();
        this.props.onCancel();
      };
      this.renderPopoverContent = () => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'url' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
        const {
          url,
          isTargetBlank,
          isNoFollow
        } = this.state;
        return /*#__PURE__*/_jsx(LinkForm, {
          isNew: false,
          url: url,
          isTargetBlank: isTargetBlank,
          isNoFollow: isNoFollow,
          showText: false,
          onChange: this.handleChange,
          onConfirm: this.handleConfirm,
          onCancel: this.handleCancel,
          onRemove: this.handleRemove
        });
      };
      this.state = this.getCleanState();
    }
    render() {
      // @ts-expect-error ts-migrate(2339) FIXME
      const {
        open,
        onOpenChange
      } = this.props;
      return /*#__PURE__*/_jsx(EventBoundaryPopover, {
        open: open,
        onOpenChange: onOpenChange,
        Content: this.renderPopoverContent,
        closeOnOutsideClick: true,
        animateOnToggle: false,
        children: /*#__PURE__*/_jsx(Child, Object.assign({}, this.props, {
          togglePopover: this.togglePopover
        }))
      });
    }
  }
  ImageLinkPopover.displayName = 'ImageLinkPopover';
  ImageLinkPopover.propTypes = {
    open: PropTypes.bool.isRequired,
    onOpen: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    url: PropTypes.string,
    isTargetBlank: PropTypes.bool,
    isNoFollow: PropTypes.bool,
    onOpenChange: PropTypes.func.isRequired
  };
  ImageLinkPopover.defaultProps = {};
  return ImageLinkPopover;
});